/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_200_TitleInputs */

const es_gift_option_200_title = /** @type {(inputs: Gift_Option_200_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lobo de Mar`)
};

const gl_gift_option_200_title = /** @type {(inputs: Gift_Option_200_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lobo de Mar`)
};

const en_gift_option_200_title = /** @type {(inputs: Gift_Option_200_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Old Salt`)
};

/**
* | output |
* | --- |
* | "Old Salt" |
*
* @param {Gift_Option_200_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_200_title = /** @type {((inputs?: Gift_Option_200_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_200_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_200_title(inputs)
	if (locale === "en") return en_gift_option_200_title(inputs)
	return es_gift_option_200_title(inputs)
});